import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useQuery } from "@tanstack/react-query";
import { NavLink, useSearchParams } from "react-router-dom";
import PageHeading from "@/v2/components/ui/heading/Page";
import parseUrlToQueryParams from "../../../utils/parseUrlToQueryParams";
import { DataTable, TableToolbar } from "@/v2/components/data-table/table";
import { Payslip } from "@/v2/types";
import AccessControl from "@/v2/components/rbac/AccessControl";
import FindAllPayslip from "@/v2/api/payslip/FindAll";
import {
    FreelancerPayslipColumn,
    FreelancerPayslipFilterColumn,
} from "@/v2/components/data-table/columns/FreelancerPayslipColumn";
import MonthYearPicker from "@/v2/components/ui/MonthPicker";
import { useState } from "react";
import { UTCDate } from "@date-fns/utc";
import { format } from "date-fns";

export default function FreelancerPayslipPage() {
    const [searchParams, _setSearchParams] = useSearchParams();
    const queryParams = parseUrlToQueryParams(searchParams);

    const now = new UTCDate();
    const currentMonth = format(now, "yyyy-MM");
    const appliedMonth = searchParams.get("month");

    const [month, setMonth] = useState(appliedMonth || currentMonth);

    const monthNumber = Number(month.split("-")[1]);

    const { skip, limit, search, filter } = queryParams;

    const { refetch, ...query } = useQuery({
        queryKey: ["payslip", skip, limit, search, filter, month],
        queryFn: () =>
            FindAllPayslip({
                limit: limit ?? 20,
                skip: skip ?? 0,
                search: search,
                filter: {
                    ...filter,
                    type: { eq: ["HOURLY"] },
                    month: { eq: monthNumber },
                },
            }),
    });

    return (
        <>
            <div className="flex flex-wrap items-center justify-between gap-4 py-2">
                <PageHeading
                    title="Freelancer Payslip Database"
                    description="Manage and monitor all freelance payslips in your platform"
                />

                <div className="flex items-center justify-center gap-2">
                    <MonthYearPicker month={month} setMonth={setMonth} />
                    <AccessControl
                        module="PAYSLIP_MANAGEMENT"
                        requestedAccess={"POST"}
                    >
                        <div className="flex gap-4">
                            <NavLink to={"create"}>
                                <Button>Add New Freelancer Payslip</Button>
                            </NavLink>
                        </div>
                    </AccessControl>
                </div>
            </div>

            <Card className="p-2">
                <TableToolbar<Payslip>
                    column={FreelancerPayslipFilterColumn}
                    searchPlaceHolder="Search payslip.."
                />

                <DataTable<Payslip>
                    data={query.data?.data.payslips || []}
                    columns={FreelancerPayslipColumn}
                    loading={query.isLoading || query.isFetching}
                    pagination={query?.data?.pagination!}
                />
            </Card>
        </>
    );
}
